import { Component, CUSTOM_ELEMENTS_SCHEMA, effect, inject, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormField } from '../../form/abstracts';
import { MaxDistanceFieldService } from './services/max-distance-field.service';
import { MAX_DISTANCE_WALKING_LABELS } from './config/constants';

@Component({
  selector: 'app-max-distance-field',
  standalone: true,
  imports: [TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: MaxDistanceFieldComponent
    },
  ],
  templateUrl: './max-distance-field.component.html',
  styleUrls: ['./max-distance-field.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MaxDistanceFieldComponent extends BaseFormField<number> {
  // Inputs
  public form: InputSignal<FormGroup> = input.required<FormGroup>();
  public formControlName: InputSignal<string> = input.required<string>();
  
  // Services
  private _maxDistanceFieldService = inject(MaxDistanceFieldService);
  
  // Local properties
  protected sliderValue: number = 30; // Initialize with 1km default value (30 maps to 1000)
  protected maxDistanceWalkingLabels = MAX_DISTANCE_WALKING_LABELS;
  private  _maxDistanceWalking = this._maxDistanceFieldService.getCurrentMaxDistanceWalking();
  
  // Effects
  /**
   * Updates slider value when max distance walking changes
   * Maintains exact original behavior
   */
  updateSlideOnLabelChange = effect(() => {
    this.sliderValue = this._maxDistanceFieldService.mapValueToSliderValue(this._maxDistanceWalking());
  }, { allowSignalWrites: true });

  // Methods
  /**
   * Handles slider max distance change event
   * Delegates to service while maintaining exact original behavior
   */
  public handleSliderMaxDistanceChange(event: Event) {
    const slider = event.target as HTMLInputElement;
    const value = Number(slider.value);
    const control = this.form().get(this.formControlName());
    
    this._maxDistanceFieldService.handleSliderMaxDistanceChange(value, control);
  }
  
  /**
   * Handles max distance walking label click event
   * Delegates to service while maintaining exact original behavior
   */
  public handleMaxDistanceWalkingLabelClick(value: number) {
    const control = this.form().get(this.formControlName());
    this._maxDistanceFieldService.handleMaxDistanceWalkingLabelClick(value, control);
  }
}
